import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormContainer = styled.div`
  margin: 10px 0;
`

export const sectionTitle = css`
  margin-bottom: 16px;
`

export const checkbox = css`
  padding: 2px;
`

export const autocomplete = css`
  margin: 25px 0 0;

  .MuiAutocomplete-inputRoot {
    background-color: white;
  }
`
